import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';

export const CUSTOM_ERROR_CODE = {
  INCORRECT_CURRENT_PASSWORD: 'ERROR_CODE_INCORRECT_CURRENT_PASSWORD',
  LOCKED_OUT: 'ERROR_CODE_LOCKED_OUT',
  INVALID_RECAPTCHA: 'ERROR_CODE_INVALID_RECAPTCHA',
};

const useCustomErrorCode = () => {
  const { t } = useTranslation();

  const getCustomError = useCallback(
    error => {
      const code = _get(error, 'response.data.errorCode', null);

      switch (code) {
        case CUSTOM_ERROR_CODE.INCORRECT_CURRENT_PASSWORD:
          return { message: t('settings.account.incorrect_current_password'), code };
        case CUSTOM_ERROR_CODE.LOCKED_OUT:
          return { message: t('settings.account.locked_out'), code };
        case CUSTOM_ERROR_CODE.INVALID_RECAPTCHA:
          return { message: t('settings.account.invalid_recaptcha'), code };
        default:
          return {};
      }
    },
    [t]
  );

  return { getCustomError };
};

export default useCustomErrorCode;
